module.exports = __webpack_public_path__ + "img/avatar-s-16.14093ce9.jpg";